import { useRef } from "react";
import { useLazyGetRewardsByStickerQuery } from "../../services/apiSlice";
import { cn } from "../../Utils/helper";
import Detail from "./Detail";
import { isEmpty } from "lodash";

const Item = (props) => {
  const { item, onOpenRedeem, className, setCurrentStep } = props;

  const dialogRef = useRef(null);
  const [refetch, { data: rewardsData, isLoading }] =
    useLazyGetRewardsByStickerQuery();

  const handleClick = () => {
    if (onOpenRedeem && dialogRef.current) {
      dialogRef.current.open();
      refetch({ sticker_id: item.id }).then((res) => {
        if (!isEmpty(res?.data)) {
          if (["COIN", "XP"].includes(res.data.data[0].type)) {
            setCurrentStep(2);
          } else {
            setCurrentStep(1);
          }
        } else {
          setCurrentStep(1);
        }
      });
    }
  };

  if (item.background === "transparent") {
    return (
      <div className="flex items-end justify-center h-20">
        <div
          className={cn(
            "flex items-center justify-center rounded-full relative flex-shrink-0 size-[60px] 2xs:size-[70px] aspect-square border border-dashed border-mid-gray",
            className,
          )}
        />
      </div>
    );
  }

  return (
    <>
      <div
        className={`flex items-end justify-center h-20 ${onOpenRedeem ? "cursor-pointer" : ""}`}
        onClick={handleClick}
      >
        <div
          className={cn(
            "flex items-center justify-center rounded-full shadow-badge relative flex-shrink-0 size-[60px] 2xs:size-[70px] aspect-square",
            className,
          )}
          style={{ background: item.background || "#ECEEFF" }}
        >
          {item.is_new && (
            <p className="bg-destructive text-white py-[1px] px-[6px] text-[9px] font-bold rounded-xl absolute top-[-10px] left-1/2 -translate-x-1/2 z-10">
              New
            </p>
          )}
          <p className="bg-primary text-white py-[1px] px-[5px] text-[11px] font-bold rounded-xl absolute bottom-0 right-[-2px] z-10">
            {item.total_available}
          </p>
          <div className="size-full rounded-full border-none">
            <img
              className="size-full object-cover rounded-full"
              src={
                item?.image_data
                  ? `${process.env.REACT_APP_URL_IMAGE}/${item?.image_data?.file_path}`
                  : "/images/brand.jpg"
              }
              alt=""
            />
          </div>
        </div>
      </div>

      {onOpenRedeem && (
        <Detail
          ref={dialogRef}
          data={{ ...item, reward: rewardsData?.data[0] }}
          onRedeem={onOpenRedeem}
          loading={isLoading}
        />
      )}
    </>
  );
};

export default Item;
